import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconModule } from '@sb/library/icon';
import { RepertoireAssignmentStatusPipe } from './pipes/repertoire-assignment-status.pipe';
import { StudentStatusPipe } from './pipes/student-status.pipe';
import { StatusLabelComponent } from './status-label.component';
import { CheckTruncateDirective } from './pipes/check-truncate.directive';

@NgModule({
    declarations: [
        StatusLabelComponent,
        StudentStatusPipe,
        RepertoireAssignmentStatusPipe,
        CheckTruncateDirective
    ],
    imports: [
        CommonModule,
        IconModule,
        MatTooltipModule
    ],
    exports: [
        StatusLabelComponent,
        StudentStatusPipe,
        RepertoireAssignmentStatusPipe,
    ]
})
export class StatusLabelModule { }
